import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import DeleteClientDoc from "../Modal/DeleteClientDoc";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DocEdit from "../Modal/DocEdit";
import AddDocument from "../Modal/AddDocument";
import ReactTost from "../../ReactTost";

function DocList() {
  const { id } = useParams();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [docId, setDocId] = useState("");
  const [editModalShow, setEditModalShow] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [document, setDocument] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [userDelete, setUserDelete] = useState(true);
  const [deletedId, setDeletedId] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const { t } = useTranslation();
  const fetchDoc = () => {
    axios
      .get(`${API_URL}/${API_VERSION}/users/doc?id=${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setDocument(response.data.results);
        setUserDelete(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDoc();
  }, [id, API_URL, API_VERSION, userDelete]);

  function openDeleteUserDocAlert(id) {
    setDeletedId(id);
    setModalShow(true);
  }

  function deleteUser(uId) {
    if (uId) {
      axios
        .delete(`${API_URL}/${API_VERSION}/users/doc/${uId}`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setUserDelete(true);
          setModalShow(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  
  return (
    <>
      <section className="doc_bot">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          <Row>
            <Col md={12}>
              <div className="d-flex align-items-center justify-content-between mb-4">
                <Link className="button" to="/admin/clients">
                  <i className="fa-solid fa-arrow-left"></i> {t("Back")}
                </Link>
                <div className="head_title"></div>
                <Link className="button" onClick={() => setAddModalShow(true)}>
                  <i className="fa-solid fa-circle-plus"></i>
                  {t("New Document")}
                </Link>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center flex-column align-items-center">
            {document &&
              document.map((doc, index) => {
                let iconClass = doc.type === "pdf" ? "fa-file-pdf" : "fa-file";
                let mb = doc.size > 1024 ? "MB" : "KB";
                let sizeinMB =
                  doc.size > 1024
                    ? Math.round(doc.size / 1024)
                    : Math.round(doc.size);
                //const sizeInKB = Math.round(doc.size / 1024);

                // const formattedSize = formatFileSize(doc.size);
                return (
                  <Col lg={12} className="mb-3">
                    <Card>
                      <Card.Body>
                        <div className="w-100 d-flex justify-content-center resonsive_box">
                          <div className="imgbox">
                            <i className={`fa-solid fa-fw ${iconClass}`}></i>
                          </div>
                          <div className="infobox">
                            <div className="info">
                              <span>{doc.name}</span>
                            </div>
                            <div className="small_info">
                              <div className="dot"></div>
                              <div className="info_size">
                                <span className="size">
                                  {sizeinMB}
                                  {mb}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="action_box">
                          <Link
                            className="button"
                            onClick={() => {
                              setEditModalShow(true);
                              setDocId(doc.id);
                            }}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Link>
                          <Button
                            variant="danger"
                            onClick={() => {
                              openDeleteUserDocAlert(doc.id);
                            }}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </section>
      <AddDocument
        show={addModalShow}
        doc={fetchDoc}
        onHide={() => {
          setAddModalShow(false);
        }}
      />
      <DeleteClientDoc
        show={modalShow}
        onHide={() => setModalShow(false)}
        onDelete={() => deleteUser(deletedId)}
      />
      <DocEdit
        show={editModalShow}
        doc={fetchDoc}
        id={docId}
        onHide={() => {
          setEditModalShow(false);
        }}
      />
    </>
  );
}

export default DocList;
